import http from "@/settings/apiSettings"

class TrepteVechimeDataService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/PER_EmpJobsHistoryBenefits", data)
    }
}
export default new TrepteVechimeDataService()